import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "m9.94 2.372 1.59-1.6A2.6 2.6 0 0 1 13.38 0h.006c1.057 0 2.01.635 2.414 1.607a2.6 2.6 0 0 1-.563 2.838l-1.608 1.602zM8.904 3.414l-8.762 8.82a.49.49 0 0 0-.142.343v2.934A.49.49 0 0 0 .49 16h2.946c.13 0 .255-.052.347-.143l8.805-8.773z"
    }, null, -1)
  ]))]))
}
export default { render: render }